import EZAxios from '@/ezaxios';

export default {
  getBanner() {
    return EZAxios.get(`home-banner`);
  }
};
